<template>
    <flussonicEmbedPlayer
            v-if="isItPlayable"
            v-bind:cameraToken="token"
            v-bind:cameraName="name"
            v-bind:cameraTitle="title"
            v-bind:cameraOwner="owner"
            v-bind:cameraStreamer="streamer"
            v-bind:httpsEnabled="httpsEnabled"
            v-bind:cameraAutoPlay="cameraAutoPlay"
    ></flussonicEmbedPlayer>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {eventEmitter} from "../../main";
    import setRules from "../../assets/setRules";
    import Cameras from "../../plugins/controllers/cameras";
    import flussonicEmbedPlayer from "../../components/players/FlussonicEmbedPlayer.vue";

    export default {
        name: "Player",
        components: {
            flussonicEmbedPlayer
        },
        data() {
            return {
                "name": "",
                "title": "",
                "owner": "",
                "token": "",
                "streamer": "",
                "httpsEnabled": false,
                "cameraAutoPlay": false
            }
        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getApiData);
            this.getApiData();
        },
        beforeDestroy() {
            if (this.e) {
                this.e.forEach(el => {
                    el.destroy();
                });
            }
            eventEmitter.$off("tokenSuccess", this.getApiData);
        },
        methods: {
            getApiData() {
                this.name = this.$route.params.name;
                this.httpsEnabled = true;
                this.cameraAutoPlay = true;

                Cameras.getCameraByName(this.name).then((response) => {
                    setRules(response);
                    this.streamer = response.data.server;
                    this.token = response.data.token;
                    this.title = response.data.title;
                    this.owner = response.data.owner;
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        computed: {
            ...
                mapState(["tokenSuccess", "showLargePopup"]),
            isItPlayable: function () {
                return ((this.name !== null) && (this.name !== '') && typeof this.name !== 'undefined' &&
                    (this.token !== null) && (this.token !== '') && typeof this.token !== 'undefined' &&
                    (this.streamer !== null) && (this.streamer !== '') && typeof this.streamer !== 'undefined');
            }
        }
    }
</script>

<style scoped>

</style>